/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IClient } from "../../models/Machines/ClientContracts";

import {
  SET_MACHINE_SEARCH_VALUE,
  SET_MACHINE_CURRENT_SELECTION,
  SET_MACHINE_CURRENT_NAME,
  SET_MACHINE_CURRENT_SELECTED_TAB
} from "./types";

export const setMachineSearchValue = (searchValue?: string) => {
  return {
    type: SET_MACHINE_SEARCH_VALUE,
    searchValue
  }
}

export const setCurrentMachineName = (currentName?: string) => {
  return {
    type: SET_MACHINE_CURRENT_NAME,
    currentName
  }
}

export const setCurrentMachineSelection = (currentSelection: IClient) => {
  return {
    type: SET_MACHINE_CURRENT_SELECTION,
    currentSelection
  }
}

export const setMachineSelectedTab = (currentSelectedTab: string | null) => {
  return {
    type: SET_MACHINE_CURRENT_SELECTED_TAB,
    currentSelectedTab
  };
};
